import { Layout, Menu, Button, Drawer, Grid } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Logo from "../../resources/img/gmr.png"

const Navbar = () => {

    const { Header } = Layout;
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    const checkScroll = () => {
        setScrolled(window.scrollY > 50);
    };

    useEffect(() => {
        window.addEventListener("scroll", checkScroll);
        checkScroll();
        return () => window.removeEventListener("scroll", checkScroll);
    }, []);

    useEffect(() => {
        setOpen(false);
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [location.pathname]);

    const menuItems = [
        {
            key: "/",
            label: <Link to="/">Home</Link>,
        },
        {
            key: "/gmr-enlaces/nosotros",
            label: <Link to="/gmr-enlaces/nosotros">Nosotros</Link>,
        },
        {
            key: "/gmr-enlaces/servicios",
            label: <Link to="/gmr-enlaces/servicios">Servicios</Link>,
        },
        {
            key: "/gmr-enlaces/contacto",
            label: <Link to="/gmr-enlaces/contacto">Contacto</Link>,
        },
        // {
        //     key: "#",
        //     label: <Button variant="solid" color="primary" size="small">
        //         <Link to="#">Cotización</Link>
        //     </Button>,
        // },
    ];

    return (
        <>
            <Header
                style={{
                    position: "fixed",
                    width: "100%",
                    zIndex: 1000,
                    transition: "all 0.3s ease",
                    background:
                        scrolled
                            ? "rgba(14, 29, 52, 0.9)"
                            : "transparent",
                    backdropFilter: scrolled ? "blur(10px)" : "none",
                }}
            >
                <div
                    style={{
                        maxWidth: 1300,
                        margin: "0 auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    {/* Logo */}
                    <Link to="/" style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <img src={Logo} alt="logo" style={{ height: 40 }} />
                        <h2 style={{ color: "#fff", margin: 0 }}>GMR</h2>
                    </Link>

                    {/* Desktop Menu */}
                    {screens.xl ? (
                        <Menu
                            mode="horizontal"
                            selectedKeys={[location.pathname]}
                            items={menuItems}
                            style={{
                                background: "transparent",
                                border: "none",
                                fontWeight: 500,
                                padding: "20px 20px"
                            }}
                        />
                    ) : (
                        <>
                            <Button
                                type="text"
                                icon={<MenuOutlined />}
                                onClick={() => setOpen(true)}
                                style={{ color: "#fff", fontSize: 20 }}
                            />

                            <Drawer
                                title="Menú"
                                placement="right"
                                onClose={() => setOpen(false)}
                                open={open}
                            >
                                <Menu
                                    mode="vertical"
                                    selectedKeys={[location.pathname]}
                                    items={menuItems}
                                />
                            </Drawer>
                        </>
                    )}
                </div>
            </Header>
        </>
    )
}

export default Navbar
